import { acuityRequestsTyped } from "@/api/(requests)/acuityTyped";
import type { CurrentAcuityScoreResponse, UUID } from "@/core/types";

export async function getCurrentAcuityScore(patientId: UUID): Promise<CurrentAcuityScoreResponse> {
  return acuityRequestsTyped.get_current_acuity_score({
    context: { showLoader: false },
    urlParams: { patientId },
  });
}
